import React, { useEffect, useState } from "react"
import "./lightbox.css"

const Lightbox = ({
  children,
  imageUrl,
  imageAlt = "",
  linkUrl,
  linkLabel = "View Project",
  closeLabel = "Close image",
}) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (!isOpen) return undefined

    const handleKeyDown = event => {
      if (event.key === "Escape") setIsOpen(false)
    }

    document.addEventListener("keydown", handleKeyDown)
    return () => document.removeEventListener("keydown", handleKeyDown)
  }, [isOpen])

  useEffect(() => {
    if (!imageUrl) return undefined

    const preloadImage = document.createElement("img")
    preloadImage.decoding = "async"
    preloadImage.src = imageUrl

    return undefined
  }, [imageUrl])

  if (!imageUrl) return children

  const open = () => setIsOpen(true)

  const openWithKeyboard = event => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      setIsOpen(true)
    }
  }

  return (
    <>
      <div
        aria-haspopup="dialog"
        className="rv-lightbox-trigger"
        onClick={open}
        onKeyDown={openWithKeyboard}
        role="button"
        tabIndex={0}
      >
        {children}
      </div>
      {isOpen && (
        <div
          aria-label="Image lightbox"
          aria-modal="true"
          className="rv-lightbox-backdrop"
          onMouseDown={event => {
            if (event.target === event.currentTarget) setIsOpen(false)
          }}
          role="dialog"
        >
          <div className="rv-lightbox-content">
            <img alt={imageAlt} className="rv-lightbox-image" src={imageUrl} />
            {linkUrl && (
              <a
                className="rv-lightbox-link"
                href={linkUrl}
                rel="noopener noreferrer"
                target="_blank"
              >
                {linkLabel}
              </a>
            )}
            <button
              aria-label={closeLabel}
              autoFocus
              className="rv-lightbox-close"
              onClick={() => setIsOpen(false)}
              type="button"
            >
              ×
            </button>
          </div>
        </div>
      )}
    </>
  )
}

export default Lightbox
